import {NavbarMainComponent} from "../components/body/navbar.component";
import {AboutComponent, ClientComponent, ContactComponent, InformationComponent} from "../components/about.component";
import { FooterComponent } from "../components/body/footer.component";
import {
    ProductDetailComponent,
    ProductInformationComponent,
    ProductSpectionficationComponent,
} from "../components/view/product-detail.component";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import apiJson from "../helper/axios";
import {ProductsComponent} from "../components/products.component";
import {Helmet} from "react-helmet";
import {SEOProductDetail} from "../helper/seo";
import HelpPopup from "../components/HelperPopUp.component";

function Products() {
    const { slug } = useParams();
    const [product, setProduct] = useState(null);
    const [relatedProducts, setRelatedProducts] = useState([]);
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const getDataProducts = async () => {
        try {
            const response = await apiJson.get("/product/xray", {
                params: { slug: slug },
            });
            setProducts( response?.data?.data?.product || []);
        } catch (err) {
            console.error("Error fetching products:", err);
            setError("Error fetching products");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const storedProducts = localStorage.getItem("products");
        if (storedProducts) {
            const products = JSON.parse(storedProducts);
            setProducts(products);
            setLoading(false);
        } else {
            getDataProducts();
        }
    }, []);


    useEffect(() => {
        if (products.length > 0) {
            // Cari produk saat ini berdasarkan slug
            const currentProduct = products.find((p) => p.slug === slug);
            setProduct(currentProduct);

            // Filter produk terkait, kecuali produk saat ini
            const related = products
                .filter((p) => p.slug !== slug)
                .sort(() => Math.random() - 0.5) // Acak urutan
                .slice(0, 4); // Ambil 4 teratas

            setRelatedProducts(related);
        }
    }, [products, slug]);

    if (loading) return <div>Loading...</div>;
    if (error) return <div>{error}</div>;


    return (
        <>
            <SEOProductDetail product={product}/>
            <NavbarMainComponent />
            <div className="mt-28 md:mt-20">
                <div className="pt-10 md:mb-10">
                    {product ? (
                        <div style={{maxWidth:"1500px"}} className={"mx-auto"}>
                            <ProductDetailComponent product={product} />
                            <ProductSpectionficationComponent specification={product?.product_specification} />
                        </div>
                    ) : (
                        <p>Loading product details...</p>
                    )}
                </div>
                <ProductsComponent label={"PRODUK TERKAIT"} products={relatedProducts} />
                <AboutComponent />
                <InformationComponent />
                <ClientComponent />
            </div>
            <FooterComponent />
            <HelpPopup />
        </>
    );
}

export default Products;
